export enum FormTab {
  SUPPLY = 'supply',
  BORROW = 'borrow',
  WITHDRAW = 'withdraw',
  REPAY = 'repay',
}
